// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

/**
 *
 * @param theme
 */
/**
 * Component overrides for theme
 * @param theme - Material-UI theme object
 * @returns Theme component overrides configuration
 */
export default function InputLabel(theme: any): any {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: theme.palette.grey[600],
        },
        outlined: {
          lineHeight: "0.8em",
          "&.MuiInputLabel-sizeSmall": {
            lineHeight: "1em",
          },
          "&.MuiInputLabel-shrink": {
            background: theme.palette.background.paper,
            padding: "0 8px",
            marginLeft: -6,
            lineHeight: "1.4375em",
          },
        },
      },
    },
  };
}
